import { render, staticRenderFns } from "./paymentBank.vue?vue&type=template&id=6be78f48"
import script from "./paymentBank.vue?vue&type=script&lang=js"
export * from "./paymentBank.vue?vue&type=script&lang=js"
import style0 from "./paymentBank.vue?vue&type=style&index=0&id=6be78f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports